import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { Badge } from "@/components/ui/badge";

/**
 * Round 7 Workstream F - "Include TEST" switch for an operational view.
 * Rendered ONLY for an authorised administrator (canInclude); everyone else
 * sees nothing and TEST stays out of their views. When on, a clear badge says
 * so - the state is never silent. Pair with useIncludeTest():
 *
 *   const { includeTest, canInclude, setIncludeTest } = useIncludeTest();
 *   <IncludeTestToggle includeTest={includeTest} canInclude={canInclude} onChange={setIncludeTest} />
 */
export function IncludeTestToggle({ includeTest, canInclude, onChange, testId = "include-test", className = "" }) {
  if (!canInclude) return null;
  const id = `${testId}-switch`;
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid={`${testId}-toggle`}>
      <Switch id={id} data-testid={id} checked={!!includeTest} onCheckedChange={onChange}
        aria-describedby={`${testId}-help`} />
      <Label htmlFor={id} className="text-xs cursor-pointer">Include TEST</Label>
      {includeTest ? (
        <Badge variant="outline" data-testid={`${testId}-badge`}
          className="bg-[hsl(var(--test))]/15 text-[hsl(var(--test))] border-[hsl(var(--test))]/30 border text-[10px]"
          title="TEST fixtures are shown alongside business records. Counts on this view include them.">
          TEST records included
        </Badge>
      ) : (
        <span id={`${testId}-help`} className="text-[11px] text-muted-foreground hidden sm:inline">
          TEST records are hidden
        </span>
      )}
    </div>
  );
}
